const firstName = ({ data }) => data.first_name

const lastName = ({ data }) => data.last_name

export default {
    firstName,
    lastName
}